import { render, staticRenderFns } from "./myBuddy.vue?vue&type=template&id=23c69d70&"
import script from "./myBuddy.vue?vue&type=script&lang=js&"
export * from "./myBuddy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports